import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { images } from '../../assets/images';

import { routes } from '../../routes';

class TopBar extends React.Component {
    render() {
        return (
            <>
            <div className='navshadow'>
                <div className="topbar d-lg-block d-none">
                    <Container>
                        <Row className="align-items-center">
                            <Col xl={2} lg={2} md={3} sm={12} xs={12}>
                                <Link to={routes.index} className="logo_area">
                                    <img src={images.Logo} alt="..." className="img-fluid" />
                                </Link>
                            </Col>
                            <Col xl={10} lg={10} md={9} sm={12} xs={12}>
                                <div className="topbar_right_area">
                                    <div className="d-flex align-items-center justify-content-end">
                                        <div className="topbar_item">
                                            <div className="social_icons">
                                                <ul className="list-inline">
                                                    <li>
                                                        <Link to={{ pathname: "https://www.facebook.com/" }} target="_blank">
                                                            <i className="fab fa-facebook-f"></i>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={{ pathname: "https://www.twitter.com" }} target="_blank">
                                                            <i className="fab fa-twitter"></i>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={{ pathname: "https://in.linkedin.com/" }} target="_blank">
                                                            <i className="fab fa-linkedin-in"></i>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={{ pathname: "https://www.youtube.com/" }} target="_blank">
                                                            <i className="fab fa-youtube"></i>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={{ pathname: "https://www.blogger.com/" }} target="_blank">
                                                            <i className="fab fa-blogger"></i>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={{ pathname: "https://www.google.com" }} target="_blank">
                                                            <i className="fab fa-google-plus-g"></i>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={{ pathname: "https://telegram.org/" }} target="_blank">
                                                            <i className="fab fa-telegram-plane"></i>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={{ pathname: "https://web.skype.com" }} target="_blank">
                                                            <i className="fab fa-skype"></i>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={{ pathname: "https://www.google.com" }} target="_blank">
                                                            <i className="fas fa-rss"></i>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to={{ pathname: "https://web.whatsapp.com" }} target="_blank">
                                                            <i className="fab fa-whatsapp"></i>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="topbar_item">
                                            <div className="top_contact_info">
                                                <div className="icon_area">
                                                    <i className="fas fa-phone-alt"></i>
                                                </div>
                                                <div className="info_area">
                                                    <h6>Call Us On</h6>
                                                    <span><a href="tel: +1-8000-978-6543">+1-8000-978-6543</a></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="topbar_item">
                                            <div className="top_contact_info">
                                                <div className="icon_area">
                                                    <i className="fas fa-envelope-open"></i>
                                                </div>
                                                <div className="info_area">
                                                    <h6>Mail Us @</h6>
                                                    <span><a href="mailto:info@techcruizer.com">info@techcruizer.com</a></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
            <div className='phone-view d-lg-none d-block'>
            <Container>
                    <Row className="align-items-center">
                        <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                                <div className='phone_set'>
                                <div className='left_area_logo'>
                                    <Link to={routes.index} className="logo_area">
                                        <img src={images.Logo} alt="..." className="img-fluid" />
                                    </Link>
                                </div>
                                <div className='right_area_humber'>
                                    <Link to={routes.phonemenu}><i class="fal fa-bars"></i></Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            </>
        );
    }
}

export default TopBar;